import { defineStore } from "pinia";
import MD5 from "md5.js";
import {
  apiLogin,
  apiGetPlayer,
  apiLoginout,
  apiCheckUserWallet,
  apiGetRemainderGold,
} from "@/api/login";
import {
  getAccountId,
  isLogin,
  setAccountId,
  setLoginKey,
  getLoginKey,
  setCurrentGame,
} from "@/js/account/index";

import { message } from "ant-design-vue";
import { usePlayGameStore } from "./playGame";
import { EVENTCMD } from "@/js/events";
import IPCCenter from "@/js/ipc";
import { formatHumanTime } from "@/js/utils";
import { useGameListStore } from "./gameList";
import { useVipStore } from "./vip";
import {
  apiGetWebPopupNoticeConfig,
  apiPurchasedGameDetail,
  apiPurchasedGames,
} from "@/api/home";
import { useLayoutDataStore } from "./layoutData";
import { yunpb } from "@/types/protobuf";
import { localCache } from "@/js/localCache";

// import pb from "@pb/index.json";
// import router from "@/router";
// import * as config from "@/config";
// import * as Accounts from "@js/account";
// import IPCCenter from "@js/ipc";
// import { EVENTCMD } from "@js/events";
// import stastic from "@js/stastic";

interface loginConfig {
  flag: string;
  token: string;
  loginType: number;
  id?: string;
  version?: string;
  phone?: string;
  passwordMd5?: string;
}

interface requestError {
  message: string;
  description?: { desc: string };
}

export const useloginStore = defineStore("login", {
  state: () => ({
    isShow: false, // 登录框展示与隐藏
    userInfo: {} as pro.yunpb.IPlayer, // 用户信息
    time: 60, // 验证码倒计时
    disabled: false, // 获取验证码按钮禁用
    timer: null, // 验证码倒计时轮训
    playedTime: 0, // TODO: 暂时不用 --- 已玩时长
    restTime: 0, // 剩余时长
    freeTime: 0, // 免费时长
    addTime: 0, // 加时卡时长
    priorityTime: 0, // 秒进卡时长
    priorityTimeExpireTime: 0, // 秒进卡过期时间点
    golds: 0, // 金币数
    gems: 0, // 宝石数
    isNewUser: false, // 是否新用户
    isPayuser: false, // 是否付费用户
    webFreeTime: 0, // 赠送的免费时间 废弃
    isBvip: false, // 是否大会员
    isShowRecharge: false, // 充值弹窗显示
    isShowRechargeTab: 0, // 充值弹窗显示后的tab激活索引
    buyGoodModalGoodsId: 0, // 充值时，使用的商品id
    buyGoodModalGoodsKind: 0, // 充值时，使用的充值类型
    isSignIn: isLogin(), // 是否登录
    // 充值、购买商品等状态变更
    isUserPaySuccess: false,
    currentNavTab: 0, // 当前Header组件的Tab
    webPopupNoticeConfig: {} as yunpb.IGetWebPopupNoticeConfigRes,
  }),
  getters: {
    isChikiiVip: (state: any) => {
      console.log(state.userInfo?.vipInfo, "isChikiiVip");
      return !!state.userInfo?.vipInfo;
    },
    gameTimeRemaining: (state: any) => {
      return formatHumanTime(state.restTime);
    },
  },
  actions: {
    setup() {
      this.getPlayer();
      this.getWebPopupNoticeConfig();
    },
    update_isShowRecharge(isShow: boolean, tab = 0) {
      if (!isLogin()) {
        this.setIsModalVisable(true);
        return;
      }
      this.isShowRecharge = isShow;
      this.isShowRechargeTab = tab;
    },
    update_isUserPaySuccess(isShow: boolean) {
      this.isUserPaySuccess = isShow;
    },
    // 修改登录弹窗的显示隐藏
    setIsModalVisable(isShow: boolean) {
      this.isShow = isShow;
    },
    // 修改当前tab
    setNavTab(currentNavTab: number) {
      this.currentNavTab = currentNavTab;
    },
    // 4代表web端
    async chikiiLogin(config: loginConfig) {
      const md5 = new MD5();
      const { loginType, token, flag, phone, passwordMd5 } = config;
      // new MD5().update(`${data.password}`).digest("hex")
      try {
        const res = await apiLogin({
          loginType,
          code: token,
          deviceType: 4,
          activityChannel: 0,
          phone,
          passwordMd5: md5.update(`${passwordMd5}`).digest("hex"),
        });
        setLoginKey(res.key as string);
        setAccountId(res.userId);
        this.isSignIn = isLogin();
        this.getPlayer();
        this.isShow = false;
        console.log(res, `${flag}Res`);
      } catch (error) {
        const err = error as any;
        message.error(err?.desc || "login faild");
        console.log(error, `${flag}Err`);
      }
    },

    clearLoginState() {
      const playGameStore = usePlayGameStore();
      const gameListStore = useGameListStore();

      setAccountId(null);
      setLoginKey(null);
      setCurrentGame(null);
      this.userInfo = {};
      playGameStore.setIsPlaying(false);
      this.isSignIn = isLogin();
      console.log(this.isSignIn, "isSignIn");
      // 退出登录清空历史游戏数据
      gameListStore.changeHistoryGame([]);
    },

    // 退出登录
    async chikiiLoginOut() {
      try {
        await apiLoginout({
          key: getLoginKey(),
        });
        this.clearLoginState();
        useVipStore().clearVip();
        message.success({
          content: "sign out success",
        });
        IPCCenter.getInstance().broadCastEvent(EVENTCMD.Logout, {});
      } catch (error) {
        const err = error as requestError;
        message.error({
          content: err.description?.desc || err.message || "sign out failed",
        });
      }
    },
    // 登录后获取玩家数据
    async getPlayer() {
      if (!isLogin()) return;
      try {
        const { player, isPayuser } = await apiGetPlayer({
          id: getAccountId(),
          idFlag: 0,
        });
        this.userInfo = player as pro.yunpb.IPlayer;
        this.isPayuser = isPayuser || false;
        this.getWallet();
        this.getPurchasedGameList();
        useVipStore().fetchVipPageInfo(); //获取用户会员信息
        console.log(player, "getPlayer");
      } catch (error) {
        console.log(error, "getPlayerErr");
      }
    },
    // 获取用户钱包
    async getWallet() {
      if (!this.isSignIn) return;
      try {
        const res = await apiCheckUserWallet({});
        this.gems = res.gem as number;
        this.golds = res.gold as number;
        console.log(res, "apiCheckUserWallet");
      } catch (error) {
        console.log(error, "apiCheckUserWallet");
      }
    },
    // 获取用户游戏时长
    async getGameTime() {
      if (!this.isSignIn) return;
      try {
        const res: any = await apiGetRemainderGold({});
        this.restTime = res.time;
        this.playedTime = res.playTime;
        this.freeTime = res.freeTime;
        // this.addTime =
        console.log(res, "apiGetRemainderGold");
      } catch (error) {
        console.log(error, "apiGetRemainderGold");
      }
    },
    // 获取已购买游戏
    async getPurchasedGameList(activePurchasedGamesId?: number) {
      const layoutDataStore = useLayoutDataStore();
      try {
        const res = await apiPurchasedGames({});
        layoutDataStore.updateStateProp("purchasedGamesData", res.gameData);
        if (layoutDataStore.purchasedGamesData.length) {
          const findPurchasedGames = res.gameData?.find(
            (item: any) => activePurchasedGamesId === item.id
          );
          layoutDataStore.updateStateProp(
            "activePurchasedGames",
            findPurchasedGames || layoutDataStore.purchasedGamesData[0]
          );
        }
        console.log(res, "apiPurchasedGames");
      } catch (error) {
        console.log(error, "apiPurchasedGames");
      }
    },
    async getWebPopupNoticeConfig() {
      const layoutDataStore = useLayoutDataStore();
      const WEBVERSIONUPDATETIME = localCache.getItem(
        "WEBVERSIONUPDATETIME",
        1
      );
      try {
        const res = await apiGetWebPopupNoticeConfig({});
        this.webPopupNoticeConfig = res;
        if (!res.updateTimestamp) return;
        if (!WEBVERSIONUPDATETIME) {
          console.log(WEBVERSIONUPDATETIME, "WEBVERSIONUPDATETIME");
          localCache.setItem("WEBVERSIONUPDATETIME", res.updateTimestamp, 1);
          layoutDataStore.updateStateProp("webVersionUpdateModal", true);
          return;
        }
        if (Number(WEBVERSIONUPDATETIME) < res.updateTimestamp) {
          console.log(Number(WEBVERSIONUPDATETIME) < res.updateTimestamp);
          localCache.setItem("WEBVERSIONUPDATETIME", res.updateTimestamp, 1);
          layoutDataStore.updateStateProp("webVersionUpdateModal", true);
        }
      } catch (error) {
        console.log(error, "getWebPopupNoticeConfigErr");
      }
    },
  },
});
